// Estado inicial da aplicação com configurações padrão
export const initialState = {
    isDarkMode: false,                  // Indica se o modo escuro está ativo
    mainLayout: 'app',                  // Layout principal (ex: app, auth)
    theme: 'system',                    // Tema atual (light, dark, system)
    menu: 'vertical',                   // Tipo de menu (vertical, horizontal, etc)
    layout: 'full',                     // Layout da página (full, boxed)
    rtlClass: 'ltr',                    // Direção do texto (ltr ou rtl)
    animation: 'animate__fadeInDown',   // Classe CSS para animação ativa
    navbar: 'navbar-sticky',            // Estilo da navbar
    locale: 'pt',                       // Código do idioma atual
    sidebar: false,                     // Se a sidebar está aberta
    languageList: [                     // Lista de idiomas disponíveis
        { code: 'pt', name: 'Portuguese' },
        { code: 'en', name: 'English' },
        // { code: 'zh', name: 'Chinese' },
        // { code: 'da', name: 'Danish' },
        // { code: 'fr', name: 'French' },
        // { code: 'de', name: 'German' },
        // { code: 'el', name: 'Greek' },
        // { code: 'hu', name: 'Hungarian' },
        // { code: 'it', name: 'Italian' },
        // { code: 'ja', name: 'Japanese' },
        // { code: 'pl', name: 'Polish' },
        // { code: 'ru', name: 'Russian' },
        // { code: 'es', name: 'Spanish' },
        // { code: 'sv', name: 'Swedish' },
        // { code: 'tr', name: 'Turkish' },
        // { code: 'ae', name: 'Arabic' },
    ],
    isShowMainLoader: true,       // Exibe loader principal
    semidark: false,              // Modo semiescuro ativado
};
